<template>
  <div
    style="margin-left: auto; margin-right: auto;"
    :style="{
      width: wrapWidth < 1376 ? '90%' : '75%'
    }"
  >
    <slot name="title">
      <div v-if="title" class="text-center" style="font-size: 30px; font-weight: 500;color: #333">{{ title }}</div>
    </slot>
    <slot name="default" />
  </div>
</template>

<script>
export default {
  name: 'dss-card',
  props: {
    title: { type: String, default: null },
    wrapWidth: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
  .dss-card {
    max-width: 1100px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/dss/dss-card.vue